// src/utils/base64ToPdf.js

const base64ToPdf = (
  base64String,
  fileName = "document.pdf",
  download = false,
) => {
  const base64Data = base64String.replace(/^data:application\/pdf;base64,/, "");
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  if (download) {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    window.open(url, "_blank");
  }

  URL.revokeObjectURL(url);
};

export default base64ToPdf;
